import { Answer, AnswerItem, QuestionTypes, ViewApi } from 'interface';
import { post } from 'scripts/api';
import { portalAnswers } from 'scripts/storage';
import { API } from 'data';
import { FileManager } from 'scripts/fileManager';

export function offlinePortalKioskSubmit(id?: number) {
    portalAnswers
        .getAll()
        .filter((item) => item.id !== id)
        .forEach((answer) => {
            post<ViewApi>(API.answers.addView, { publish: answer.publish }).then((view) => {
                post<Answer>(API.answers.addAnswer, { view: view.data.view_id }).then((res) =>
                    submitAnswerItem(answer.items, res.data, answer.id, res.data.form.workspace.id),
                );
            });
        });
}

function submitAnswerItem(data: AnswerItem[], answer: Answer, id: number, ws?: number | string) {
    portalAnswers.removeAnswer(id);
    const promises: Promise<any>[] = [];
    data.forEach((answerItem) => {
        const objApi: {
            value?: string;
            answer: number;
            question: number;
            question_items?: number[];
            answer_file?: (number | string)[];
        } = {
            value: answerItem.value,
            answer: answer.id,
            question: answerItem.question.id,
        };
        if (!answerItem.value) objApi.question_items = answerItem.question_items?.map((i) => i.id);
        if ([QuestionTypes.camera, QuestionTypes.file, QuestionTypes.voice].includes(answerItem.question.input_type))
            FileManager.UploadFile(answerItem.question, answer.access_token ?? '', ws, objApi.value).then((res) => {
                // post answer item for file base questions if file uploaded
                if (res) {
                    objApi.answer_file = res.map((i) => i.id); // res: file url
                    if (answer.access_token)
                        promises.push(post<AnswerItem>(API.answers.answerItem(answer.access_token), objApi));
                }
            });
        else if (answer.access_token)
            promises.push(post<AnswerItem>(API.answers.answerItem(answer.access_token), objApi));
    });
    Promise.all(promises).then(() => {
        if (answer.access_token) post(API.answers.closeAnswer(answer.access_token), {});
    });
}
